import { Box, Skeleton } from '@mui/material';

export const BrandPlaceholder = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <Skeleton
        variant='rectangular'
        sx={{
          width: '100%',
          height: 120,
        }}
      />

      <Skeleton
        variant='rectangular'
        sx={{ width: '60%', height: '18px', mt: 1 }}
      />
    </Box>
  );
};
